/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { createDialogRoute } from '@gh/common-shared';
import { DialogInput } from '@gh/core-ui';
import { OfficeInfo } from '@gh/supplier-shared';

export interface SupplierOfficeInfoDialogConfig {
  office: OfficeInfo;
}

@Component({
  selector: 'gh-supplier-office-info-dialog',
  templateUrl: 'supplier-office-info-dialog.component.html',
  styleUrls: ['supplier-office-info-dialog.component.scss'],
})
export class SupplierOfficeInfoDialogComponent implements DialogInput<SupplierOfficeInfoDialogConfig> {
  input: SupplierOfficeInfoDialogConfig;

  get office(): OfficeInfo {
    return this.input.office;
  }

  constructor(private dialogRef: MatDialogRef<any>) {
  }

  onClose(): void {
    this.dialogRef.close();
  }
}

export const supplierOfficeInfoDialogRoute = createDialogRoute({
  component: SupplierOfficeInfoDialogComponent,
});
